import { render, staticRenderFns } from "./WalletMenu.vue?vue&type=template&id=779401dc&"
import script from "./WalletMenu.vue?vue&type=script&lang=js&"
export * from "./WalletMenu.vue?vue&type=script&lang=js&"
import style0 from "./WalletMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports